import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { FileText, ArrowLeft } from 'lucide-react';
import { Layout } from '@/components/wiki/Layout';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function TermsPage() {
  const [terms, setTerms] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const response = await axios.get(`${API}/terms`);
        setTerms(response.data);
      } catch (error) {
        console.error('Error fetching terms:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchTerms();
  }, []);

  if (loading) {
    return (
      <Layout>
        <div className="max-w-5xl mx-auto px-4 py-8">
          <div className="animate-pulse space-y-4">
            <div className="h-10 bg-[#eaecf0] rounded w-1/3" />
            <div className="h-4 bg-[#eaecf0] rounded w-full" />
            <div className="h-4 bg-[#eaecf0] rounded w-full" />
            <div className="h-4 bg-[#eaecf0] rounded w-2/3" />
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="max-w-5xl mx-auto px-4 py-8" data-testid="terms-page">
        <Link to="/" className="inline-flex items-center gap-2 text-[#36c] hover:underline mb-6">
          <ArrowLeft className="h-4 w-4" />
          Back to Home
        </Link>

        <div className="bg-white rounded-sm border border-[#a2a9b1] p-8">
          {/* Header */}
          <div className="flex items-center gap-3 mb-6 pb-4 border-b border-[#c8ccd1]">
            <div className="w-12 h-12 rounded-full bg-[#eaf3ff] flex items-center justify-center">
              <FileText className="h-6 w-6 text-[#36c]" />
            </div>
            <div>
              <h1 className="font-serif text-2xl font-bold text-[#202122]">{terms?.title}</h1>
              <p className="text-sm text-[#54595d]">Last updated: {terms?.last_updated}</p>
            </div>
          </div>

          {/* Content */}
          <div className="prose max-w-none">
            {terms?.content && (
              <div 
                className="text-[#202122] space-y-4"
                dangerouslySetInnerHTML={{ 
                  __html: terms.content
                    .replace(/^# (.+)$/gm, '<h1 class="font-serif text-2xl font-bold mt-8 mb-4 text-[#202122] border-b border-[#c8ccd1] pb-2">$1</h1>')
                    .replace(/^## (.+)$/gm, '<h2 class="font-serif text-xl font-semibold mt-6 mb-3 text-[#202122] border-b border-[#c8ccd1] pb-1">$1</h2>')
                    .replace(/^### (.+)$/gm, '<h3 class="font-semibold mt-4 mb-2 text-[#202122]">$1</h3>')
                    .replace(/^- (.+)$/gm, '<li class="ml-4 text-[#202122]">$1</li>')
                    .replace(/\n\n/g, '</p><p class="mb-4 text-[#202122]">')
                }} 
              />
            )}
          </div>

          {/* Report Link */}
          <div className="mt-8 p-4 bg-[#f8f9fa] rounded-sm border border-[#c8ccd1]">
            <p className="text-sm text-[#54595d]">
              If you believe content on Handshake violates these terms, please{' '}
              <Link to="/report" className="text-[#36c] font-medium hover:underline">
                report it here
              </Link>.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
}
